if (!customElements.get('prior-era-hero-carousel')) {
  customElements.define(
    'prior-era-hero-carousel',
    class PriorEraHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewport = this.querySelector('[data-carousel-viewport]');

        this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.previous(true));
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.next(true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.carouselDot), true)));
        this.addEventListener('keydown', this.onKeydown);
        this.viewport?.addEventListener('pointerdown', this.onPointerDown);
        this.viewport?.addEventListener('pointerup', this.onPointerUp);
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.start);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.start);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.show(this.currentIndex);
        this.start();
      }

      disconnectedCallback() {
        this.pause();
        this.removeEventListener('keydown', this.onKeydown);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointerup', this.onPointerUp);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(index, restart = false) {
        if (this.slides.length === 0) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        const current = this.querySelector('[data-carousel-current]');
        if (current) current.textContent = String(this.currentIndex + 1).padStart(2, '0');
        if (restart) {
          this.pause();
          this.start();
        }
      }

      next = (restart = false) => this.show(this.currentIndex + 1, restart);
      previous = (restart = false) => this.show(this.currentIndex - 1, restart);

      start = () => {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.reducedMotion.matches) return;
        this.pause();
        this.timer = window.setInterval(this.next, Number(this.dataset.interval) || 8000);
      };

      pause = () => {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      };

      onKeydown = (event) => {
        if (event.key === 'ArrowLeft') this.previous(true);
        if (event.key === 'ArrowRight') this.next(true);
      };

      onPointerDown = (event) => {
        if (event.target.closest('a, button')) return;
        this.pointerStart = event.clientX;
      };

      onPointerUp = (event) => {
        if (this.pointerStart == null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) < 50) return;
        distance > 0 ? this.previous(true) : this.next(true);
      };

      onVisibilityChange = () => (document.hidden ? this.pause() : this.start());

      onBlockSelect = (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) {
          this.pause();
          this.show(index);
        }
      };
    }
  );
}
